import React from 'react';
const NotFound = (props) => {
    return (
        <div className="error page">
            sorry nothing found
        </div>
    )
}
export default NotFound;